import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { TableData } from "../../state/Supplier/TableData";

const updateSupplierTableData: Reducer<TableData> = (state: TableData = new TableData(), action: Action<ActionType, TableData>) => {
  switch (action.type) {
    case ActionType.SUPPLIER_TABLE_DATA_FETCHED:
      return { ...state, records:  action.data  };
    default:
      return state;
  }
};

export default updateSupplierTableData;
